import script from "./XLButton.vue?vue&type=script&setup=true&lang=js"
export * from "./XLButton.vue?vue&type=script&setup=true&lang=js"

import "./XLButton.vue?vue&type=style&index=0&id=26159734&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26159734"]])

export default __exports__